import SchoolsList from './src/SchoolsList';

export default SchoolsList;
